import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import bigCog from '@adsk/bim360-matrix-react-assets/cog-big.svg';
import smallCog from '@adsk/bim360-matrix-react-assets/cog-small.svg';

import './_ProcessingCogs.scss';

/**
 * A component that displays two cog graphics spinning next to each other in different directions to denote something is processing.
 */
const ProcessingCogs = ({ className, ...restProps }) => {
  return (
    <div {...restProps} className={classNames('ProcessingCogs__container', className)}>
      <SvgIcon className="ProcessingCogs__big-cog">{bigCog}</SvgIcon>
      <SvgIcon className="ProcessingCogs__small-cog">{smallCog}</SvgIcon>
    </div>
  );
};

ProcessingCogs.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

export default ProcessingCogs;
